import { render, staticRenderFns } from "./FraisTransportAgence.vue?vue&type=template&id=87be70ca&scoped=true&"
import script from "./FraisTransportAgence.vue?vue&type=script&lang=js&"
export * from "./FraisTransportAgence.vue?vue&type=script&lang=js&"
import style0 from "./FraisTransportAgence.vue?vue&type=style&index=0&id=87be70ca&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be70ca",
  null
  
)

component.options.__file = "FraisTransportAgence.vue"
export default component.exports